import { render, staticRenderFns } from "./TemplateGallery.vue?vue&type=template&id=16e668a6&scoped=true&"
import script from "./TemplateGallery.vue?vue&type=script&lang=js&"
export * from "./TemplateGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e668a6",
  null
  
)

export default component.exports